var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8335 6.16665H7.8335V1.16665C7.8335 0.945633 7.7457 0.733671 7.58942 0.577391C7.43314 0.421111 7.22118 0.333313 7.00016 0.333313C6.77915 0.333313 6.56719 0.421111 6.41091 0.577391C6.25463 0.733671 6.16683 0.945633 6.16683 1.16665V6.16665H1.16683C0.945816 6.16665 0.733854 6.25444 0.577574 6.41072C0.421294 6.567 0.333496 6.77897 0.333496 6.99998C0.333496 7.22099 0.421294 7.43295 0.577574 7.58923C0.733854 7.74552 0.945816 7.83331 1.16683 7.83331H6.16683V12.8333C6.16683 13.0543 6.25463 13.2663 6.41091 13.4226C6.56719 13.5788 6.77915 13.6666 7.00016 13.6666C7.22118 13.6666 7.43314 13.5788 7.58942 13.4226C7.7457 13.2663 7.8335 13.0543 7.8335 12.8333V7.83331H12.8335C13.0545 7.83331 13.2665 7.74552 13.4228 7.58923C13.579 7.43295 13.6668 7.22099 13.6668 6.99998C13.6668 6.77897 13.579 6.567 13.4228 6.41072C13.2665 6.25444 13.0545 6.16665 12.8335 6.16665Z",
    fill: "#4C8AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.676d22a0d3239a16363765d3641063f6.svg";
export { ForwardRef as ReactComponent };